import { render, staticRenderFns } from "./task-view.vue?vue&type=template&id=23e2faf3&scoped=true&"
import script from "./task-view.vue?vue&type=script&lang=js&"
export * from "./task-view.vue?vue&type=script&lang=js&"
import style0 from "./task-view.vue?vue&type=style&index=0&id=23e2faf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e2faf3",
  null
  
)

export default component.exports